/**
 * A Button.
 *
 * -- Props --
 * | Name         | Type      | Required  | Default Value | Description
 * |--------------|-----------|-----------|---------------|---------------
 * | id           | string    | false     | null          | An id to apply to this component.
 * | className    | string    | false     | ""            | Additional classes to apply to this component.
 * | disabled     | boolean   | false     | false         | Whether the button is disabled or not.
 * | href         | string    | false     | null          | An href for on-click events.
 * | target       | string    | false     | _blank        | The href target.
 * | onClick      | function  | false     | null          | An onClick handler.
 * | onMouseLeave | function  | false     | null          | An onMouseLeave function.
 * | tooltip      | string    | false     | null          | A tooltip to display.
 */
export const Button = (props) => {
    if (props.disabled) {
        const btn = (
            <button id={props.id || null}
                    className={`button${props.className ? " " + props.className : ""}`}
                    disabled={true}
                    style={{ pointerEvents: 'none', userSelect: 'none' }}
                    data-tooltip={props.tooltip}
            >
                {props.children}
            </button>
        );
        return props.title
            ? <span title={props.title} style={{ display: 'inline-block', cursor: 'not-allowed' }}>{btn}</span>
            : btn;
    }

    if (props.href) {
        return (
            <a id={props.id || null}
               className={`button${props.className ? " " + props.className : ""}`}
               href={props.href}
               target={props.target || "_blank"}
               onClick={props.onClick}
               onMouseLeave={props.onMouseLeave}
               title={props.title}
               data-tooltip={props.tooltip}
            >
                {props.children}
            </a>
        );
    }

    return (
        <button id={props.id || null}
                type={props.type || "button"}
                className={`button${props.className ? " " + props.className : ""}`}
                onClick={props.onClick}
                onMouseLeave={props.onMouseLeave}
                title={props.title}
                data-tooltip={props.tooltip}
        >
            {props.children}
        </button>
    );
};

export default Button;
